export { default } from './StylesProvider';
export * from './StylesProvider';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/StylesProvider/index.js
// module id = 422
// module chunks = 2